<div class="container">
  <mat-toolbar color="primary" class="custom-header">
  <button mat-icon-button (click)="closeModal()">
    <mat-icon svgIcon="mat:chevron_left"></mat-icon>
  </button>
</mat-toolbar>
  <img src="../../../../../assets/img/trophy.svg" alt="" *ngIf="trophy.unlocked">
  <img src="../../../../../assets/img/trophy_locked.svg" alt="" *ngIf="!trophy.unlocked">
  <h2>{{ trophy.i18nTitle[translate.currentLang.toUpperCase()] }}</h2>
  <p>{{ trophy.i18nDescription[translate.currentLang.toUpperCase()] }}</p>
</div>
